// src/pages/Faq.js
// v1 (Jan 14, 2026) – Security & Privacy FAQ (Irish school-friendly)

import React from "react";
import { Helmet } from "react-helmet";
import "../styles/Privacy.css";

const Faq = () => {
  return (
    <div className="privacy-page page">
      <Helmet>
        <title>Security & Privacy FAQ - Ghrianghraffy</title>
        <meta
          name="description"
          content="Security & Privacy FAQ for Ghrianghraffy — answers for Irish schools and parents about privacy, GDPR, website embeds, and realistic expectations."
        />
      </Helmet>

      <div className="privacy-card">
        <header className="privacy-header">
          <p className="privacy-kicker">FAQ</p>
          <h1 className="privacy-title">Security &amp; Privacy FAQ</h1>
          <p className="privacy-meta">Last updated: January 14, 2026</p>
        </header>

        <section className="privacy-section">
          <h2 className="privacy-section-title">Can parents download or screenshot photos?</h2>
          <p>
            Like all platforms that display photos (including Instagram, WhatsApp, and school
            portals), screenshots and screen recording cannot be technically prevented.
          </p>
          <p>
            GhrianGhraffy reduces risk by avoiding permanent links, limiting access to authorised
            users, and discouraging misuse at scale.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-section-title">Are photos publicly visible on the internet?</h2>
          <p>
            No. GhrianGhraffy does not provide public discovery or search, and media is not exposed
            via permanent public links.
          </p>
          <p>
            If a school chooses to publish selected items on their own website, only approved
            content is shown and access links are time-limited.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-section-title">Is this safer than Google Drive, Dropbox, or email?</h2>
          <p>
            In most school scenarios, yes. Shared folders and email attachments often create
            long-lived links or copies that can be forwarded indefinitely.
          </p>
          <p>
            GhrianGhraffy is designed to avoid permanent links and to keep control within a
            school-scoped, role-based system.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-section-title">Do photos get stored on teachers’ phones?</h2>
          <p>
            The app is designed to minimise local storage. Working copies may exist temporarily
            during capture and upload, and are removed after successful upload or cancellation.
          </p>
          <p>
            Photos already in a device’s camera roll remain under the user’s own control.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-section-title">Who can see our school’s photos?</h2>
          <p>
            Access is role-based and scoped to a school. Principals and authorised staff manage and
            review content. Parents see approved content only.
          </p>
          <p>
            There is no cross-school browsing and no global public gallery.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-section-title">What happens when a staff member leaves?</h2>
          <p>
            School administrators can revoke access immediately. Former staff lose access without
            affecting the school’s content.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-section-title">Is GhrianGhraffy GDPR-friendly?</h2>
          <p>
            GhrianGhraffy supports GDPR compliance through access control, data minimisation,
            security safeguards, and deletion/revocation mechanisms.
          </p>
          <p>
            In most school use cases, the school is the data controller for pupil media and
            GhrianGhraffy acts as a data processor on the school’s behalf.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-section-title">Does GhrianGhraffy sell data or show ads?</h2>
          <p>
            No. GhrianGhraffy does not sell personal data, does not run advertising, and does not
            use content for marketing.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-section-title">How does the school website plugin work?</h2>
          <p>
            If a school chooses to embed galleries on their website (for example via WordPress),
            the website requests approved items through controlled server-side calls, and media is
            delivered via time-limited links.
          </p>
          <p>
            Website publishing is optional and can be disabled by the school.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-section-title">How do we request deletion or changes?</h2>
          <p>
            As data controller, The Principal (School Adminitrator) can easily delete files using
            their Principal Dashboard.
            Either way, you can always Contact us at{" "}
            <a href="mailto:privacy@ghrianghraffy.com">privacy@ghrianghraffy.com </a>
            and we will work with the school as needed.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Faq;
